/* Skinique theme JS: header, menus, reveal animations, accordions, cookie consent, toasts. */
(function () {
  'use strict';

  if (window.__skThemeInit) return;
  window.__skThemeInit = true;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- sticky header ---------- */
  var header = document.querySelector('[data-header]');
  var logoRow = document.querySelector('[data-header-logo-row]');
  var SCROLLED = ['bg-background/90', 'backdrop-blur-md', 'shadow-elegant', 'border-b', 'border-border'];
  var TOP = ['bg-background/80', 'backdrop-blur-sm'];
  var LOGO_OPEN = ['max-h-20', 'pt-4', 'pb-2'];
  var LOGO_CLOSED = ['max-h-0', 'pt-0', 'pb-0'];

  function onScroll() {
    if (!header) return;
    var scrolled = window.scrollY > 50;
    SCROLLED.forEach(function (c) { header.classList.toggle(c, scrolled); });
    TOP.forEach(function (c) { header.classList.toggle(c, !scrolled); });
    if (logoRow) {
      LOGO_OPEN.forEach(function (c) { logoRow.classList.toggle(c, !scrolled); });
      LOGO_CLOSED.forEach(function (c) { logoRow.classList.toggle(c, scrolled); });
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- mobile booking CTA + mobile menu ---------- */
  /* Three booking buttons exist on mobile: this fixed pill, the drawer's own,
     and the footer's. Exactly one is on screen at a time - the pill yields to
     the drawer while the menu is open, and to the footer once the footer is in
     view. body.sk-menu-open lets the stylesheet hide the footer's. */
  var stickyBook = document.querySelector('[data-sk-sticky-book]');
  var footerEl = document.getElementById('contact');
  var menuOpen = false;
  /* Footer visibility is measured from its rectangle rather than watched with
     IntersectionObserver: plain geometry is synchronous and testable, and the
     observer-based version this replaces could not be verified. */
  var footerOnScreen = function () {
    if (!footerEl) return false;
    var r = footerEl.getBoundingClientRect();
    return r.top < window.innerHeight && r.bottom > 0;
  };
  var applyStickyBook = function () {
    if (!stickyBook) return;
    var on = !menuOpen && !footerOnScreen();
    stickyBook.classList.toggle('hidden', !on);
    stickyBook.setAttribute('aria-hidden', String(!on));
  };
  if (stickyBook) {
    window.addEventListener('scroll', applyStickyBook, { passive: true });
    window.addEventListener('resize', applyStickyBook, { passive: true });
    applyStickyBook();
  }

  var menuToggle = document.querySelector('[data-mobile-menu-toggle]');
  var mobileMenu = document.querySelector('[data-mobile-menu]');
  if (menuToggle && mobileMenu) {
    var setMenuState = function (open) {
      menuOpen = open;
      menuToggle.setAttribute('aria-expanded', String(open));
      menuToggle.querySelector('[data-icon-menu]').classList.toggle('hidden', open);
      menuToggle.querySelector('[data-icon-close]').classList.toggle('hidden', !open);
      document.body.classList.toggle('sk-menu-open', open);
      applyStickyBook();
    };
    menuToggle.addEventListener('click', function () {
      setMenuState(mobileMenu.classList.toggle('hidden') === false);
    });
    mobileMenu.addEventListener('click', function (e) {
      if (e.target.closest('a')) {
        mobileMenu.classList.add('hidden');
        setMenuState(false);
      }
    });
  }

  /* ---------- header cart badge ---------- */
  /* The live layout is Dawn's, and Dawn refreshes its own #cart-icon-bubble
     after an add. This header renders [data-cart-count] instead, so the count
     stayed at whatever it was when the page loaded. Watch the cart requests
     and re-read /cart.js, which works for every add surface (product form,
     quick add, drawer quantity changes). */
  var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var refreshCartBadge = function () {
    fetch(cartRoot + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (badge) {
          badge.textContent = cart.item_count;
          badge.classList.toggle('hidden', cart.item_count === 0);
          badge.classList.toggle('flex', cart.item_count > 0);
        });
      })
      .catch(function () {});
  };
  if (window.fetch) {
    var nativeFetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var call = nativeFetch.apply(this, arguments);
      if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
        call.then(function (res) {
          if (!res || !res.ok) return;
          setTimeout(refreshCartBadge, 60);
          setTimeout(loadCartRecos, 120);
        }).catch(function () {});
      }
      return call;
    };
  }

  /* ---------- cart drawer: complementary products ----------
     Shopify renders the recommendations for us: ask the product-recommendations
     endpoint for the cart-recommendations section, keyed on the last line in the
     cart, and drop the HTML into the drawer's placeholder. intent=complementary
     uses the pairings curated in Search & Discovery rather than a statistical
     guess, which is what this catalogue needs.
     Re-run after every cart change, because Dawn re-renders the drawer's
     contents on each update and would otherwise wipe the slot. */
  var recosBusy = false;
  var loadCartRecos = function () {
    var slot = document.querySelector('[data-sk-cart-recos]');
    if (!slot || recosBusy) return;
    recosBusy = true;
    fetch(cartRoot + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) { slot.innerHTML = ''; slot.hidden = true; return null; }
        var last = cart.items[cart.items.length - 1];
        var ask = function (intent) {
          return fetch(cartRoot + 'recommendations/products?section_id=cart-recommendations'
            + '&product_id=' + last.product_id + '&intent=' + intent + '&limit=3')
            .then(function (r) { return r.text(); });
        };
        /* Prefer the curated pairings; fall back to Shopify's automatic related
           products so the slot is useful before anyone has curated anything,
           and upgrades itself as pairings are added in Search & Discovery. */
        return ask('complementary').then(function (html) {
          return html.indexOf('sk-recos__item') > -1 ? html : ask('related');
        }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var block = doc.querySelector('.sk-recos');
          /* Drop anything already in the cart so the slot never suggests a
             product the customer has just added. */
          if (block) {
            var have = {};
            cart.items.forEach(function (i) { have[String(i.variant_id)] = true; });
            block.querySelectorAll('[data-sk-reco-add]').forEach(function (btn) {
              if (have[btn.getAttribute('data-sk-reco-add')]) {
                var li = btn.closest('li');
                if (li) li.remove();
              }
            });
            if (!block.querySelector('li')) block = null;
          }
          slot.innerHTML = block ? block.outerHTML : '';
          slot.hidden = !block;
        });
      })
      .catch(function () { slot.innerHTML = ''; slot.hidden = true; })
      .finally(function () { recosBusy = false; });
  };

  /* Adding from the slot: post to the cart, then let Dawn re-render its own
     drawer markup so totals and line items stay authoritative. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sk-reco-add]');
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true;
    fetch(cartRoot + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-sk-reco-add')), quantity: 1 }] }),
    })
      .then(function () { return fetch(cartRoot + '?sections=cart-drawer'); })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var host = document.querySelector('#CartDrawer');
        var fresh = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html').querySelector('#CartDrawer');
        if (host && fresh) host.innerHTML = fresh.innerHTML;
      })
      .catch(function () {})
      .finally(function () { btn.disabled = false; loadCartRecos(); });
  });

  /* Populate when the drawer opens, and once at load for an already-open cart. */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open], .cart-drawer__open, #cart-icon-bubble')) setTimeout(loadCartRecos, 300);
  });
  loadCartRecos();

  /* ---------- dropdowns (header shop menu + shop nav) ---------- */
  document.querySelectorAll('[data-dropdown]').forEach(function (dd) {
    var toggle = dd.querySelector('[data-dropdown-toggle]');
    var panel = dd.querySelector('[data-dropdown-panel]');
    if (!toggle || !panel) return;
    var hideTimer;
    var hoverOpenedAt = 0; /* touch fires mouseenter+click together: the click must not instantly close */
    function show() { clearTimeout(hideTimer); panel.classList.remove('hidden'); toggle.setAttribute('aria-expanded', 'true'); }
    function hide() { panel.classList.add('hidden'); toggle.setAttribute('aria-expanded', 'false'); }
    dd.addEventListener('mouseenter', function () { hoverOpenedAt = Date.now(); show(); });
    dd.addEventListener('mouseleave', function () { hideTimer = setTimeout(hide, 120); });
    toggle.addEventListener('click', function () {
      if (panel.classList.contains('hidden')) { show(); }
      else if (Date.now() - hoverOpenedAt > 350) { hide(); }
    });
    document.addEventListener('click', function (e) { if (!dd.contains(e.target)) hide(); });
  });

  /* ---------- practice/shop mode switch: preview the other menu in place ---------- */
  var MODE_ON = ['bg-primary', 'text-primary-foreground'];
  document.querySelectorAll('[data-sk-mode-btn]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var mode = btn.getAttribute('data-sk-mode-btn');
      document.querySelectorAll('[data-sk-nav]').forEach(function (nav) {
        nav.style.display = nav.getAttribute('data-sk-nav') === mode ? '' : 'none';
      });
      document.querySelectorAll('[data-sk-mode-btn]').forEach(function (b) {
        var on = b.getAttribute('data-sk-mode-btn') === mode;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        MODE_ON.forEach(function (c) { b.classList.toggle(c, on); });
        b.classList.toggle('text-muted-foreground', !on);
      });
    });
  });

  /* ---------- reveal on scroll: intentionally inert ----------
     The scoped CSS build never applied the .reveal hidden state in production
     (see styles/theme.source.css), so sections have always been visible from
     first paint. Nothing is hidden or toggled here on purpose: an opacity:0
     initial state on first-viewport content would gate the LCP element on this
     deferred bundle (perf pass, 2026-09-05). Re-enabling the fade-in is a design
     decision; if revived, only elements below the initial viewport may start
     hidden. */

  /* ---------- single-open accordions ---------- */
  document.querySelectorAll('[data-accordion="single"]').forEach(function (group) {
    group.addEventListener('toggle', function (e) {
      var target = e.target;
      if (!(target instanceof HTMLDetailsElement) || !target.open) return;
      group.querySelectorAll('details[open]').forEach(function (other) {
        if (other !== target) other.open = false;
      });
    }, true);
  });

  /* ---------- smooth anchors ---------- */
  document.querySelectorAll('[data-anchor-link]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = a.getAttribute('href');
      if (!id || id.charAt(0) !== '#') return;
      var el = document.querySelector(id);
      if (!el) return;
      e.preventDefault();
      el.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth' });
    });
  });

  /* ---------- toast ---------- */
  window.skiniqueToast = function (title, description) {
    var container = document.getElementById('ToastContainer');
    if (!container) return;
    var toast = document.createElement('div');
    toast.className = 'pointer-events-auto bg-foreground text-primary-foreground rounded-xl px-5 py-4 shadow-lg border border-primary-foreground/10 max-w-xs translate-y-2 opacity-0 transition-all duration-300';
    var t = document.createElement('p');
    t.className = 'text-sm font-medium';
    t.textContent = title;
    toast.appendChild(t);
    if (description) {
      var d = document.createElement('p');
      d.className = 'text-xs text-primary-foreground/70 mt-0.5';
      d.textContent = description;
      toast.appendChild(d);
    }
    container.appendChild(toast);
    requestAnimationFrame(function () {
      toast.classList.remove('translate-y-2', 'opacity-0');
    });
    setTimeout(function () {
      toast.classList.add('translate-y-2', 'opacity-0');
      setTimeout(function () { toast.remove(); }, 300);
    }, 3000);
  };

  /* ---------- Google Maps: load only on explicit request ----------
     Nothing is requested from Google until the visitor clicks. */
  document.querySelectorAll('[data-sk-map-load]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var wrap = btn.closest('[data-sk-map]');
      if (!wrap) return;
      var src = wrap.getAttribute('data-sk-map-src');
      if (!src) return;
      var frame = document.createElement('iframe');
      frame.src = src;
      frame.width = '100%';
      frame.height = '100%';
      frame.style.border = '0';
      frame.loading = 'lazy';
      frame.referrerPolicy = 'no-referrer-when-downgrade';
      frame.title = wrap.getAttribute('data-sk-map-title') || 'Map';
      frame.className = 'w-full h-full';
      wrap.innerHTML = '';
      wrap.appendChild(frame);
    });
  });

  /* ---------- cookie settings: reopen Shopify's consent preferences ----------
     Consent itself is owned by Shopify's Customer Privacy API (native banner).
     This only re-opens the preferences dialog so a visitor can change or
     withdraw a choice at any time. It never grants or infers consent, and the
     theme loads no optional technology of its own. */
  var LEGACY_CONSENT_KEY = 'skinique_cookie_consent';
  try { localStorage.removeItem(LEGACY_CONSENT_KEY); } catch (e) { /* private mode */ }

  function openPrivacyPreferences() {
    var api = window.Shopify && window.Shopify.customerPrivacy;
    if (api && typeof api.showPreferences === 'function') { api.showPreferences(); return true; }
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      window.privacyBanner.showPreferences(); return true;
    }
    return false;
  }

  document.querySelectorAll('[data-cookie-reset]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (openPrivacyPreferences()) return;
      /* The consent library loads asynchronously; retry briefly before falling
         back to the Cookie Policy, which explains how to change the choice. */
      var tries = 0;
      var timer = setInterval(function () {
        if (openPrivacyPreferences() || ++tries > 20) {
          clearInterval(timer);
          if (tries > 20) window.location.href = b.getAttribute('data-cookie-policy-url') || '/pages/sikdatnu-politika';
        }
      }, 150);
    });
  });
})();
